module.exports = __webpack_public_path__ + "static/img/img_6.f61b0db7.jpg";